module.exports = __webpack_public_path__ + "img/stock.5c40e2b3.svg";